
      import API from "!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/cjs.js!./SpecifyChatCloseReasonDialog.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/cjs.js!./SpecifyChatCloseReasonDialog.css";
       export default content && content.locals ? content.locals : undefined;
